import { Fragment, useEffect, useState } from "react";
import "./userlist.css";
import "./orderlist.css";
import { Button } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import { Link, useNavigate } from "react-router-dom";
import Loader from "../layouts/Loader";
import { toast } from "react-toastify";
import Sidebar from "./Sidebar";
// import debounce from 'lodash.debounce';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import Pagination from "react-js-pagination";
import { Modal, Box, Typography } from "@mui/material";
import {
  faCartShopping,
  faFilter,
  faPencil,
  faSearch,
  faTrash,
  faDashboard,
  faList,
  faShoppingBag,
  faSort,
  faUserPlus,
} from "@fortawesome/free-solid-svg-icons";
import { Dropdown } from "react-bootstrap";
import Drawer from "@mui/material/Drawer";
import MetaData from "../layouts/MetaData";
import axios from "axios";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

export default function Announcement() {
  const navigate = useNavigate();
  // Drawer
  const [isDrawerOpen, setIsDrawerOpen] = useState(false);

  const toggleDrawer = () => {
    setIsDrawerOpen(!isDrawerOpen);
  };

  // Navbar
  const [isMobile, setIsMobile] = useState(window.innerWidth < 1000);

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth < 1000);
    };

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const [deleteModalOpen, setDeleteModalOpen] = useState(false);

  const handleDeleteClick = (id) => {
    setSelectedId(id);
    setDeleteModalOpen(true);
  };

  const cancelDelete = () => {
    setDeleteModalOpen(false);
  };
  const [selectedAnnouncement, setSelectedAnnouncement] = useState(null);

  const [isCreateOpen, setIsCreateOpen] = useState(false);

  const resetForm = () => {
    setFormData({
      type: "",
      subject: "",

      shortDescription: "",

      contentSections: [
        {
          heading: "",
          points: [""],
          paragraphs: [""],
        },
      ],

      image: null,
      attachmentPdf: null,
      status: "pending",
    });
  };

  // FORM STATE
  const [formData, setFormData] = useState({
    type: "",
    subject: "",

    shortDescription: "",

    contentSections: [
      {
        heading: "",
        points: [""],
        paragraphs: [""],
      },
    ],

    image: null,
    attachmentPdf: null,
    status: "pending",
  });

  // HANDLE CHANGE
  const handleChange = (e) => {
    const { name, value, files } = e.target;

    if (files) {
      const file = files[0];

      setFormData((prev) => ({
        ...prev,
        [name]: file,
      }));

      // ✅ IMAGE PREVIEW
      if (name === "image") {
        setPreviewImage(URL.createObjectURL(file));
      }

      if (name === "attachmentPdf") {
        setPreviewPdf(URL.createObjectURL(file)); // ✅ preview PDF
      }
    } else {
      setFormData((prev) => ({
        ...prev,
        [name]: value,
      }));
    }
  };

  const handleSectionChange = (index, field, value) => {
    const updatedSections = [...formData.contentSections];

    updatedSections[index][field] = value;

    setFormData({
      ...formData,
      contentSections: updatedSections,
    });
  };

  const handlePointChange = (sectionIndex, pointIndex, value) => {
    const updatedSections = [...formData.contentSections];

    updatedSections[sectionIndex].points[pointIndex] = value;

    setFormData({
      ...formData,
      contentSections: updatedSections,
    });
  };

  const handleParagraphChange = (sectionIndex, paraIndex, value) => {
    const updatedSections = [...formData.contentSections];

    updatedSections[sectionIndex].paragraphs[paraIndex] = value;

    setFormData({
      ...formData,
      contentSections: updatedSections,
    });
  };

  const addNewSection = () => {
    setFormData({
      ...formData,

      contentSections: [
        ...formData.contentSections,

        {
          heading: "",
          points: [""],
          paragraphs: [""],
        },
      ],
    });
  };

  // HANDLE SUBMIT
  const handleSubmit = async (e) => {
    e.preventDefault();

    try {
      if (!formData.type || !formData.subject) {
        alert("Type and Subject are required");
        return;
      }

      const form = new FormData();

      form.append("type", formData.type);
      form.append("subject", formData.subject);
      form.append("shortDescription", formData.shortDescription);

      form.append("contentSections", JSON.stringify(formData.contentSections));

      if (formData.image) {
        form.append("image", formData.image);
      }

      if (formData.attachmentPdf) {
        form.append("pdf", formData.attachmentPdf);
      }

      await axios.post("/api/v1/admin/announcement", form, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      });

      toast.success("Announcement Created Successfully");

      await fetchAnnouncements();

      // reset form
      setFormData({
        type: "",
        subject: "",

        shortDescription: "",

        contentSections: [
          {
            heading: "",
            points: [""],
            paragraphs: [""],
          },
        ],

        image: null,
        attachmentPdf: null,
        status: "pending",
      });
      setEditId(null);
      setIsCreateOpen(false);
    } catch (error) {
      console.error(error);
      toast.error(error.response?.data?.message || "Something went wrong ❌");
    }
  };

  const [announcements, setAnnouncements] = useState([]);
  const [loading, setLoading] = useState(false);

  const fetchAnnouncements = async () => {
    try {
      setLoading(true);
      const { data } = await axios.get("/api/v1/admin/announcements", {
        withCredentials: true,
      });
      setAnnouncements(data.announcements);
      setLoading(false);
    } catch (error) {
      console.error(error);
      setLoading(false);
    }
  };
  useEffect(() => {
    fetchAnnouncements();
  }, []);

  const [selectedId, setSelectedId] = useState(null);

  const confirmDelete = async () => {
    try {
      await axios.delete(`/api/v1/admin/announcement/${selectedId}`);

      toast.success("Deleted Successfully");

      setDeleteModalOpen(false);

      fetchAnnouncements(); // refresh list
    } catch (error) {
      toast.error("Delete failed");
    }
  };

  const [isEditOpen, setIsEditOpen] = useState(false);
  const [editId, setEditId] = useState(null);

  const handleEditClick = (item) => {
    setSelectedAnnouncement(item);

    setFormData({
      type: item.type || "",

      subject: item.subject || "",

      mainHeading: item.mainHeading || "",

      mainParagraph: item.mainParagraph || "",

      listHeading: item.listSection?.heading || "",

      listItems:
        item.listSection?.items?.length > 0
          ? item.listSection.items
          : ["", "", "", ""],

      subHeading: item.subSection?.heading || "",

      subParagraphs:
        item.subSection?.paragraphs?.length > 0
          ? item.subSection.paragraphs
          : ["", ""],

      image: null,
      attachmentPdf: null,

      status: item.status || "pending",
    });

    setPreviewImage(item.image || null);

    setEditId(item._id);

    setIsEditOpen(true);
  };

  const handleUpdate = async (e) => {
    e.preventDefault();

    try {
      const form = new FormData();

      form.append("type", formData.type);
      form.append("subject", formData.subject);
      form.append("shortDescription", formData.shortDescription);

      form.append("contentSections", JSON.stringify(formData.contentSections));
      form.append("status", formData.status);

      if (formData.image) {
        form.append("image", formData.image);
      }

      if (formData.attachmentPdf) {
        form.append("pdf", formData.attachmentPdf);
      }

      await axios.put(`/api/v1/admin/announcement/${editId}`, form, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      });

      toast.success("Announcement Updated Successfully");

      setIsEditOpen(false);
      fetchAnnouncements();
    } catch (error) {
      toast.error("Update failed");
    }
  };

  const [previewImage, setPreviewImage] = useState(null);

  const [previewPdf, setPreviewPdf] = useState(null);

  const handleNotify = async (id) => {
    try {
      setNotifyingId(id); // 🔥 start loader

      await axios.post(`/api/v1/announcement/${id}/notify`);

      toast.success("Emails sent to subscribers");
    } catch (error) {
      console.error(error);

      toast.error(error.response?.data?.message || "Failed to send emails");
    } finally {
      setNotifyingId(null); // 🔥 stop loader
    }
  };

  const [notifyingId, setNotifyingId] = useState(null);

  return (
    <>
      <MetaData title={`Announcement List | GLOCRE private limited`} />
      <section className="orderlist-glc ">
        <div className="row container-fluid">
          <div className="col-12 col-md-2">
            <Sidebar />
          </div>
          <div className="col-12 col-lg-10 col-md-12 pr-0">
            <div className="mobile-logo">
              <Link to="/">
                <img src={require("../../images/procure-g-logo.png")} />
              </Link>
            </div>
            <div className="breadcrumbWrapperr">
              {/* Breadcrumbs & Menu Icon Row (For Mobile) */}
              {isMobile ? (
                <div className="row mobile-topbar">
                  <div className="col-10">
                    <ul className="breadcrumb breadcrumb2 mb-0">
                      <li>
                        <Link to="/admin/dashboard" style={{ color: "#fff" }}>
                          Dashboard
                        </Link>
                      </li>
                      <li>Announcement List</li>
                    </ul>
                  </div>
                  <div className="col-2 p-0 d-flex justify-content-center align-items-center">
                    <button className="fab" onClick={toggleDrawer}>
                      <FontAwesomeIcon icon={faList} />
                    </button>
                  </div>
                </div>
              ) : (
                <div className="row dash-navbar-big-glc small-sticky-navbar">
                  <div className="col-lg-3 col-md-12">
                    <ul className="breadcrumb breadcrumb2 mb-0">
                      <li>
                        <Link to="/admin/dashboard">Dashboard</Link>
                      </li>
                      <li>Announcement List</li>
                    </ul>
                  </div>
                  <div className="col-lg-7 col-md-6 d-flex justify-content-end align-items-end">
                    <div className="dash-cont-glc">
                      <div className="row">
                        <div className="topnav">
                          <div className="search-container">
                            <form className="d-flex">
                              <input
                                type="text"
                                placeholder="Search"
                                name="search"
                              />
                              <button type="submit">
                                <FontAwesomeIcon icon={faSearch} />
                              </button>
                            </form>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="col-lg-1 col-md-2 d-flex justify-content-center align-items-end">
                    <Dropdown className="d-inline">
                      <Dropdown.Toggle
                        variant="default"
                        id="dropdown-basic"
                        className="custom-filter-toggle"
                      >
                        <FontAwesomeIcon icon={faFilter} />
                      </Dropdown.Toggle>
                      <Dropdown.Menu>
                        <Dropdown.Item>Processing</Dropdown.Item>
                        <Dropdown.Item>Shipped</Dropdown.Item>
                        <Dropdown.Item>Delivered</Dropdown.Item>
                        <Dropdown.Item>All</Dropdown.Item>
                      </Dropdown.Menu>
                    </Dropdown>
                  </div>
                </div>
              )}
              {/* Search, Filter & Avatar Row (For Mobile) */}
              {isMobile && (
                <div className="row mobile-bottombar">
                  <div className="col-9 col-md-10 pr-0">
                    <div className="search-container">
                      <form className="d-flex">
                        <input type="text" placeholder="Search" name="search" />
                        <button type="submit">
                          <FontAwesomeIcon icon={faSearch} />
                        </button>
                      </form>
                    </div>
                  </div>
                  <div className="col-3 col-md-2  d-flex justify-content-center align-items-end">
                    <Dropdown className="d-inline">
                      <Dropdown.Toggle
                        variant="default text-white"
                        id="dropdown-basic"
                        className="text-dark dropdown1 icon-list-filter-procureg"
                        style={{
                          backgroundImage: "none",
                          border: "none",
                          boxShadow: "none",
                        }}
                      >
                        <FontAwesomeIcon icon={faFilter} />
                      </Dropdown.Toggle>
                      <Dropdown.Menu>
                        <Dropdown.Item>Processing</Dropdown.Item>
                        <Dropdown.Item>Shipped</Dropdown.Item>
                        <Dropdown.Item>Delivered</Dropdown.Item>
                        <Dropdown.Item>All</Dropdown.Item>
                      </Dropdown.Menu>
                    </Dropdown>
                  </div>
                </div>
              )}
              {/* Drawer Component */}
              <Drawer
                open={isDrawerOpen}
                onClose={toggleDrawer}
                direction="right"
                className="drawer"
              >
                <div className="drawer-header">ADMIN DASHBOARD</div>
                <div className="drawer-content">
                  <ul className="drawer-links">
                    <li>
                      <Link to="/admin/dashboard">
                        <FontAwesomeIcon icon={faDashboard} /> &nbsp;Dashboard
                      </Link>
                    </li>
                    <li>
                      <Link to="/admin/products">
                        <FontAwesomeIcon icon={faCartShopping} /> &nbsp;Product
                        List
                      </Link>
                    </li>
                    <li>
                      <Link to="/admin/products/create">
                        <FontAwesomeIcon icon={faShoppingBag} /> &nbsp;Create
                        Product
                      </Link>
                    </li>
                    <li>
                      <Link to="/admin/orders">
                        <FontAwesomeIcon icon={faSort} /> &nbsp;Announcement
                        List
                      </Link>
                    </li>
                    <li>
                      <Link to="/admin/users">
                        <FontAwesomeIcon icon={faUserPlus} /> &nbsp;User List
                      </Link>
                    </li>
                    <li>
                      <Link to="/admin/reviews">
                        <FontAwesomeIcon icon={faPencil} /> &nbsp;Review List
                      </Link>
                    </li>
                    <li>
                      <Link to="/admin/edit-banner">
                        <FontAwesomeIcon icon={faPencil} className="me-2" />
                        Banner
                      </Link>
                    </li>
                    <li>
                      <Link to="/admin/awsimages">
                        <FontAwesomeIcon icon={faPencil} className="me-2" />
                        Images
                      </Link>
                    </li>
                  </ul>
                </div>
              </Drawer>
            </div>

            <div className="row">
              <div className="col-md-10">
                <h3
                  className=""
                  style={{ color: "#ffad63", marginTop: "40px" }}
                >
                  ANNOUNCEMENT LIST
                </h3>
              </div>
              {/* <div className="col-md-2">
                <button
                  className="btn btn-primary"
                  style={{
                    backgroundColor: "#ffad63",
                    border: "none",
                    marginTop: "40px",
                  }}
                  onClick={() => {
                    resetForm();
                    setIsCreateOpen(true);
                  }}
                >
                  Create Announcement
                </button>
              </div> */}
            </div>

            <div className="cartWrapper pr-3 mt-4">
              <div className="table-responsive" style={{ overflowX: "auto" }}>
                <table className="table">
                  <thead>
                    <tr>
                      <th style={{ minWidth: "100px" }}>SI.NO</th>
                      <th style={{ minWidth: "100px" }}>DATE</th>
                      <th style={{ minWidth: "100px" }}>TYPE</th>
                      <th style={{ minWidth: "150px" }}>SUBJECT</th>
                      <th style={{ minWidth: "150px" }}>UPLOADED BY</th>
                      <th style={{ minWidth: "150px" }}>APPROVED BY</th>
                      {/* <th style={{ minWidth: "150px" }}>REJECTED BY</th> */}
                      <th style={{ minWidth: "120px" }}>STATUS</th>
                      <th style={{ minWidth: "100px" }}>ACTION</th>
                      <th style={{ minWidth: "100px" }}>NOTIFY SUBSCRIBERS</th>
                    </tr>
                  </thead>

                  <tbody>
                    {loading ? (
                      <Loader colSpan="9" />
                    ) : announcements.length === 0 ? (
                      <tr>
                        <td
                          colSpan="5"
                          className="text-center"
                          style={{ fontSize: "14px" }}
                        >
                          No Announcements
                        </td>
                      </tr>
                    ) : (
                      announcements.map((item) => (
                        <tr key={item._id}>
                          {/* ID */}
                          <td>
                            <div className="d-flex align-items-center">
                              <span
                                style={{ color: "#8c8c8c", fontSize: "15px" }}
                              >
                                {item.slNo}
                              </span>
                            </div>
                          </td>

                          {/* DATE */}
                          <td>
                            <span
                              className="cursor"
                              style={{ color: "#8c8c8c" }}
                            >
                              {new Date(item.date).toLocaleDateString()}
                            </span>
                          </td>

                          {/* TYPE */}
                          <td>
                            <span>{item.type}</span>
                          </td>

                          {/* subject */}
                          <td>
                            <span
                              style={{ color: "#8c8c8c", fontSize: "15px" }}
                            >
                              {item.subject
                                ? item.subject
                                    .split(" ")
                                    .slice(0, 1.5)
                                    .join(" ") +
                                  (item.subject.split(" ").length > 10
                                    ? "..."
                                    : "")
                                : ""}
                            </span>
                          </td>

                          {/* createdBy */}
                          <td>
                            <span
                              style={{ color: "#8c8c8c", fontSize: "15px" }}
                            >
                              {item.createdBy?.email || "-"}
                            </span>
                          </td>

                          {/* approvedBy */}
                          <td>
                            <span
                              style={{ color: "#8c8c8c", fontSize: "15px" }}
                            >
                              {item.approvedBy?.email || "-"}
                            </span>
                          </td>

                          {/* rejectedBy */}
                          {/* <td>
                            <span
                              style={{ color: "#8c8c8c", fontSize: "15px" }}
                            >
                              {item.rejectedBy?.email || "-"}
                            </span>
                          </td> */}

                          <td>
                            <span
                              style={{
                                padding: "5px 10px",
                                borderRadius: "10px",
                                fontSize: "13px",
                                fontWeight: "500",
                                backgroundColor:
                                  item.status === "approved"
                                    ? "#2f4d2a"
                                    : item.status === "rejected"
                                      ? "#f8d7da"
                                      : "#ffad63",
                                color:
                                  item.status === "approved"
                                    ? "#fff"
                                    : item.status === "rejected"
                                      ? "#721c24"
                                      : "#fff",
                              }}
                            >
                              {item.status}
                            </span>
                          </td>

                          {/* ACTION */}
                          <td>
                            <button
                              className="btn"
                             onClick={() => navigate(`/admin/editAnnouncements/${item._id}`)}
                              style={{
                                backgroundColor: "#ffad63",
                                color: "#fff",
                              }}
                            >
                              <FontAwesomeIcon icon={faPencil} />
                            </button>

                            <button
                              className="btn ms-2"
                              style={{
                                backgroundColor: "#2f4d2a",
                                color: "#fff",
                              }}
                              onClick={() => handleDeleteClick(item._id)}
                            >
                              <FontAwesomeIcon icon={faTrash} />
                            </button>
                          </td>
                          <td>
                            <button
                              className="btn"
                              style={{
                                backgroundColor: "#2f4d2a",
                                color: "#fff",
                                fontSize: "12px",
                                padding: "5px 10px",
                              }}
                              disabled={
                                item.status !== "approved" ||
                                notifyingId === item._id
                              }
                              onClick={() => handleNotify(item._id)}
                            >
                              {notifyingId === item._id
                                ? "Sending..."
                                : "Notify subscribers"}
                            </button>
                          </td>
                        </tr>
                      ))
                    )}
                  </tbody>
                </table>
                <Modal open={deleteModalOpen} onClose={cancelDelete}>
                  <Box
                    sx={{
                      position: "absolute",
                      top: "50%",
                      left: "50%",
                      transform: "translate(-50%, -50%)",
                      bgcolor: "background.paper",
                      p: 4,
                      borderRadius: 2,
                      width: 300,
                      border: "none",
                      outline: "none",
                    }}
                  >
                    <Typography
                      variant="h6"
                      mb={2}
                      align="center"
                      fontSize={17}
                      color="#8c8c8c"
                    >
                      Are you sure you want to delete this announcement? (It
                      won't be recovered)
                    </Typography>
                    <Box display="flex" justifyContent="space-between">
                      <Button
                        onClick={confirmDelete}
                        sx={{ margin: "3px" }}
                        className="left-but"
                      >
                        Yes
                      </Button>
                      <Button
                        onClick={cancelDelete}
                        sx={{ margin: "3px" }}
                        className="right-but"
                      >
                        No
                      </Button>
                    </Box>
                  </Box>
                </Modal>
               
                {/* <CreateAnnouncementModal
                  isOpen={isCreateOpen}
                  onClose={() => setIsCreateOpen(false)}
                  fetchAnnouncements={fetchAnnouncements}
                /> */}
                
                {/* <EditAnnouncementModal
                  isOpen={isEditOpen}
                  onClose={() => setIsEditOpen(false)}
                  fetchAnnouncements={fetchAnnouncements}
                  selectedAnnouncement={selectedAnnouncement}
                /> */}
              </div>
            </div>
            <br />
          </div>
        </div>
      </section>
    </>
  );
}


